/**
 * @generated SignedSource<<c8eaccf26f1d095cb0c037f5d3d690b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopIssuesFragment$data = {
  readonly topIssues: ReadonlyArray<{
    readonly type: string;
    readonly value: string;
  }>;
  readonly " $fragmentType": "TopIssuesFragment";
};
export type TopIssuesFragment$key = {
  readonly " $data"?: TopIssuesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopIssuesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopIssuesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TopIssue",
      "kind": "LinkedField",
      "name": "topIssues",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DelegateStatement",
  "abstractKey": null
};

(node as any).hash = "e29936187a3fd7f9d887034c5fb373b3";

export default node;
